export const primary = "#1A5D9A";
export const secondary = "#0993B1";
export const white = "#ffffff";
export const black = "#000000";
